import axios from 'axios'
import mensagens from '@/util/mensagens'

const tratarRotaApi = (url) =>
  window._Vue.$contextManager.handleApiPrefix(url)

export default {
  async ActionObterEmitente ({ commit }, id) {
    commit('SET_CARREGANDO_DADOS', {
      status: true,
      mensagem: mensagens.carregandoDadosEdicao
    })

    try {
      const url = tratarRotaApi('/emitente_nota_fiscal/emitente/' + id)
      const resposta = await axios.get(url)

      const payload =
        resposta.data?.retorno?.dados ||
        resposta.data?.retorno ||
        resposta.data

      commit('SET_FORMULARIO', payload)
    } finally {
      commit('SET_CARREGANDO_DADOS', {
        status: false,
        mensagem: ''
      })
    }
  },

  async ActionSalvarEmitente ({ commit }, formData) {
    commit('SET_MANIPULANDO_DADOS', {
      status: true,
      mensagem: mensagens.salvandoDadosCadastro
    })

    try {
      const url = tratarRotaApi('/emitente_nota_fiscal/salvar')
      const resposta = await axios.post(url, formData)

      return resposta.data
    } finally {
      commit('SET_MANIPULANDO_DADOS', {
        status: false,
        mensagem: ''
      })
    }
  },

  async ActionVerificarDocumentoEmitente ({ commit }, documento) {
    commit('SET_CARREGANDO_DADOS', {
      status: true,
      mensagem: mensagens.verificandoDocumentoEmitente
    })

    try {
      const url = tratarRotaApi('/emitente_nota_fiscal/verificar-documento/' + documento)
      const resposta = await axios.get(url)

      return resposta.data?.retorno ?? null
    } finally {
      commit('SET_CARREGANDO_DADOS', {
        status: false,
        mensagem: ''
      })
    }
  },

  ActionResetarDadosFormularioEmitente ({ commit }) {
    commit('SET_FORMULARIO', {
      id: null,
      razao_social: '',
      cnpj: '',
      inscricao_municipal: '',
      codigo_municipio_ibge: '',
      regime_tributario: '',
      incentivador_cultural: false,
      optante_simples_nacional: false,
      iss_retido: false,
      codigo_tributacao_nacional_issqn: '',
      codigo_cnae: '',
      regime_especial_tributacao_municipal: '0'
    })
  }
}
